import { sampleDataThemeIds } from "@repo/shared/sample-data/themes";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { SampleStep } from "~/pages/onboard/steps/sample-step";
import { activeOrganization$ } from "~/stores/organizations";

/**
 * Showcase shown to users who skipped connecting their own warehouse on
 * the datasource step. By the time we get here the server has already
 * provisioned a sample-data datasource (`SAMPLE_DATA_READER_URL` swapped
 * to the theme's database) and fired `datasource.created`, so catalog
 * sync is already in flight in the background. Continue forwards into
 * `/onboard/catalog/$datasourceId` to watch sync progress through the
 * same UI as the connected-datasource path.
 *
 * Accepts both `"sample"` and `"catalog"` so back-navigation from the
 * catalog progress screen works without bouncing the user back to the
 * resume entry.
 */
export const Route = createFileRoute("/onboard/sample")({
  validateSearch: z.object({
    datasourceId: z.string().optional(),
    themeId: z.enum(sampleDataThemeIds).optional(),
  }),
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (
      org.onboarding !== "datasource" &&
      org.onboarding !== "sample" &&
      org.onboarding !== "catalog"
    ) {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: SampleStep,
});
